// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"841dd0d9","611":"a7c9f5ef","916":"90ac87d2"}[chunkId] + ".chunk.js";
};